export default "__VITE_ASSET__DuyP$ssX__"